import { render, staticRenderFns } from "./CwvRawData.vue?vue&type=template&id=4629f968&scoped=true&"
import script from "./CwvRawData.vue?vue&type=script&lang=js&"
export * from "./CwvRawData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4629f968",
  null
  
)

export default component.exports